export default "__VITE_ASSET__2ec28754__"